import BaseAbility from 'umg-ember-backend/abilities/base';

export default class DivisionAbility extends BaseAbility {}
